<template>
<div id="">
  <v-container fluid class="pt-0 ">
    <v-row>
      <v-col cols="12" class="pt-0 ">
        <v-card style="min-height:85vh" class="admin_secondary">
          <v-card-title class="secondary white--text">
            Email Subscribers
            <v-spacer></v-spacer>
            <v-btn icon dark @click="load" :loading="loading">
              <v-icon>fa-sync</v-icon>
            </v-btn>
          </v-card-title>
          <v-container class=" white--text">
            <v-row align="center">

              <v-col cols="12" md="4" lg="3" xl="2">
                <v-text-field v-model="search" append-icon="fa-search" dark label="Search" outlined hide-details clearable></v-text-field>
              </v-col>

            </v-row>
            <v-data-table :loading="loading" :headers="headers" :items="itemsList" :search="search">


              <template v-slot:item.subscribed="{ item }">
                <v-icon :color='item.subscribed===1 ? "green" : "red"'>{{item.subscribed===1 ? "fa fa-check" : "fa fa-times"}}</v-icon>
                </template>


              <template v-slot:item.date_added="{ item }">
                          {{item.date_added |dateFormat}}
                                  </template>


              <template v-slot:item.last_newsletter_id="{ item }">
                  {{item.last_newsletter_id ? item.last_newsletter_id : "None"}}
                  </template>

              <template v-slot:item.last_newsletter_sent="{ item }">
                      {{item.last_newsletter_sent | fromNow}}
                    </template>


              <template v-slot:item.notification="{ item }">
                    <v-btn icon small color="primary" @click="$eventBus.$emit('send_notification',{account:item})"><v-icon small>fa-paper-plane</v-icon></v-btn>
                  </template>


            </v-data-table>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

</div>
</template>
<script>
import headersSimple from "./headers_simple.json"


export default {
  name: "",
  data: () => ({
    search: '',
    loading: false,
    items: [],
  }),
  computed: {
    headers() {
      return headersSimple
    },
    itemsList() {
      return this.items;
    }
  },
  methods: {
    async load() {
      this.loading = true


      this.items = await this.$api(`/account/admin/subscribers`)

      this.loading = false
    }
  },
  created() {
    this.load()
  }
}
</script>
<style lang="scss" scoped>
</style>
